import { render, staticRenderFns } from "./PageSizer.vue?vue&type=template&id=2a33d744&"
import script from "./PageSizer.vue?vue&type=script&lang=js&"
export * from "./PageSizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports